import React from 'react';

function Footer() {

    const scrollToTop = () => {
    window.scrollTo({
        top: 0,
        behavior: "smooth" 
    });
};

    return (
        <>
            <footer className="theme-bg-3 pt-30 p-relative z-index-1">
                <div className="ca-ft-shape p-absolute ft-shape-2">
                    <img
                        src="static/img/shape/shape-1.2 (1).webp"
                        alt=""
                    />
                </div>
                <div className="ca-cta-area p-relative z-index-1">
                    <div className="container">
                        <div className="ca-cta-shape3 p-absolute d-none d-lg-block">
                            <img
                                src="static/img/shape/cta-shape-3.1.webp"
                                alt=""
                            />
                        </div>
                        <div className="row align-items-center">
                            <div className="col-lg-6 mb-30">
                                <div className="ca-cta-content">
                                    <h2 className="ca-section-title cta-title-1 text-white fnw-700">
                                        Join Us Today And let Us Help You To Grow Your Business.
                                    </h2>
                                </div>
                            </div>
                            <div className="col-lg-6 mb-30">
                                <div className="ca-btn-cta-3 text-end">
                                    <a href="/contact" className="ca-btn-primary-3 w-bg">
                                        Get Started{" "}
                                        <span>
                                            <i className="fa-solid fa-angle-right" />
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="b-bottom pt-48" />
                    </div>
                </div>
                <div className="ca-footer-area">
                    <div className="container">
                        <div className="ca-ft-area w-bg">
                            <div className="row">
                                <div className="col-xl-4 col-md-6 mb-30">
                                    <div className="ca-footer widget-1">
                                        <div className="ca-ft-logo">
                                            <a href="/">
                                                <img
                                                    src="static/img/logo/head logo.webp"
                                                    alt=""
                                                />
                                            </a>
                                        </div>
                                        <div className="ca-ft-content ca-ft-content-3 mb-24">
                                            <p className="pt-16">
                                                We specialise exclusively in sourcing, supplying, and distributing high-quality copper pipes and fittings.
                                            </p>
                                        </div>
                                        <div className="ca-footer-social ca-footer-social-3">
                                            <ul>
                                                <li>
                                                    <a href="#">
                                                        <i className="fa-brands fa-instagram" />
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="#">
                                                        <i className="fa-brands fa-facebook-f" />
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="#">
                                                        <i className="fa-brands fa-linkedin-in" />
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="#">
                                                        <i className="fa-brands fa-x-twitter" />
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl col-md-6 mb-30 quick">
                                    <div className="ca-footer widget-2">
                                        <h4 className="ca-title fnw-700 theme-black-3 pb-24 pb-title">
                                            Quick Links
                                        </h4>
                                        <div className="ca-footer-menu ca-footer-menu-3">
                                            <ul>
                                                <li>
                                                    <a href="/"> Home </a>
                                                </li>
                                                <li>
                                                    <a href="/about"> About Us</a>
                                                </li>
                                                <li>
                                                    <a href="/products">Product</a>
                                                </li>
                                                 {/* <li>
                                                    <a href="/blog">Blog </a>
                                                </li> */}
                                                <li>
                                                    <a href="/contact">Contact Us </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl col-md-6 mb-30 quick">
                                    <div className="ca-footer widget-3">
                                        <h4 className="ca-title fnw-700 theme-black-3 pb-24 pb-title menu-b">
                                            Products
                                        </h4>
                                        <div className="ca-footer-menu ca-footer-menu-3 menu-b">
                                            <ul>
                                                <li>
                                                    <a href="/copper_foil_list">Copper Foil</a>
                                                </li>
                                                <li>
                                                    <a href="/copper_straight_pipe_list">Copper Straight Pipe</a>
                                                </li>
                                                <li>
                                                    <a href="/copper_pancake_list">Copper Pancake</a>
                                                </li>
                                                <li>
                                                    <a href="/copper_fitting_list">Copper Fitting</a>
                                                </li>
                                                
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-4 col-md-6 mb-30">
                                    <div className="ca-footer widget-4">
                                        <h4 className="ca-title fnw-700 theme-black-3 pb-24">
                                            Other Links
                                        </h4>
                                        <div className="ca-ft-content">
                                            <p className="pb-32">
                                                Subscribe us &amp; receive our latest news &amp; articles
                                            </p>
                                        </div>
                                        <div className="ca-footer-email-sub ca-footer-email-sub-3">
                                            <form action="#">
                                                <input type="email" placeholder="Email Address.." />
                                            </form>
                                            <button
                                                className="ca-btn-primary ca-btn-primary-3 theme-bg-3 text-white br-50"
                                                type="submit"
                                                value="submit"
                                            >
                                                Subscribe Now{" "}
                                                <span>
                                                    <i className="fa-solid fa-angle-right" />
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="copy-right-border border-1" />
                                </div>
                                <div className="col-lg-6">
                                    <p className="copry-right-text pt-24">
                                        Copyright ©2024 karmyogienterprise. All Rights Reserved
                                    </p>
                                </div>
                                <div className="col-lg-6">
                                    <div className="copy-right-menu pt-24">
                                        <ul className="term-d">
                                            <li>
                                                <a href="#">Terms &amp; Conditions</a>
                                            </li>
                                            <li>
                                                <a href="#">Privacy Policy</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>

            <button
                id="whatsappBtn"
                onClick={() => window.open('https://wa.me/916352099433', '_blank')}
                aria-label="Chat on WhatsApp"
                >
                <i className="fab fa-whatsapp"></i>
            </button>

            <button id="topBtn3" onClick={scrollToTop}>
                <i className="fa-solid fa-arrow-up" />
            </button>
        </>
    );
}

export default Footer;